const incentive = {
  dashboardModal: {
    notInterested: 'No tengo interés',
    imageAlt: 'Imagen de incentivo promocional de Clicksign',
  },
};

export default incentive;
